import mainLogo from '../../images/Revemar/revemar_automotopecas.png';
import squareLogo from '../../images/Revemar/revemar_automotopecas_color.png';
import mainLogoWhite from '../../images/Revemar/revemar_automotopecas_branco.png';
import banner01 from '../../images/Revemar/concessionaria_faixa_6.jpg';
import banner02 from '../../images/Revemar/concessionaria_faixa_2.jpg';
import banner03 from '../../images/Revemar/corp_faixa_1.jpg';
import car123 from '../../images/Revemar/123_kardian.jpg';
import box123 from '../../images/Revemar/123_revemar.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Revemar',
    defaultStoreLink: 'pecas.revemar.com.br',
    defaultContactEmail: 'antero.matos@revemar.com.br',
    whatsappNumber: '91 9302 7054',
    CNPJ: '42.282.613/0001-09',
    CNPJname: 'REVEMAR COMERCIO DE AUTOMOVEIS E UTILITARIOS LTDA',
    CNPJaddress: 'Av. Alm. Barroso, 1931 - Belém, PA - CEP: 66093-020',
    launchDate: '12/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "citroen",
        "fiat",
        "ford",
        "jeep",
        "nissan",
        "peugeot",
        "renault",
        "volkswagen",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "REVEMAR FIAT BELEM",
        "UNIQUE ANANINDEUA",
        "TROPICAL SÃO LUIS",
        "TROPICAL IMPERATRIZ",
        "FENIX BELEM",
        "FENIX PARAUAPEBAS",
        "REVEMAR VW PARAUAPEBAS",
        "REVEMAR FIAT - SÃO LUIS",
        "Du Nort Belém - Marco",
        "REVEMAR VW",
        "REVEMAR PSA BELEM",
        "Du Nort São Luís",
        // "FENIX MARABÁ",
        "TROPICAL ANANINDEUA",
        "TROPICAL DOCA",
        "TEXAS",
        "TROPICAL MARABA",
        "Du Nort Marabá",
        "Du Nort Parauapebas",
    ],
    
    disabledSellers: [
        "FENIX MARABÁ",
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Revemar</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'A história das Empresas Revemar começa na década de 80, mais precisamente no dia 26 de janeiro de 1980, quando a primeira empresa iniciou suas atividades na cidade de Marabá no estado do Pará.',
            'Com o espírito de liderança, as Empresas Revemar começam a se expandir pela Região Norte, Nordeste e centro oeste, com presença nos estados do Pará, Tocantins, Rio Grande do Norte, Maranhão, Amazonas, Acre, Roraima, Rondônia, Mato Grosso, Bahia e Sergipe, participando ativamente da economia desses estados atuando nos segmentos de distribuição de automóveis, caminhões, motocicletas, máquinas e implementos agrícolas, indústria de cimento, locação de veículos e agropecuária.'
        ],
        link: 'https://www.empresasrevemar.com.br/o-grupo/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/empresas_revemar/',
        Facebook: 'https://www.facebook.com/EmpresasRevemarOficial/',
        LinkedIn: 'https://www.linkedin.com/company/empresas-revemar/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}